import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerInfoLoadIfSelectedGuard } from 'app/core/guards/customer-info-load-if-selected.guard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { DashboardContainer } from './container/dashboard.container';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [CustomerInfoLoadIfSelectedGuard, GetDefinitionsGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
